module.exports = __webpack_public_path__ + "static/media/loyalty-icon-bonus-badge.d4becffc.png";